
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import InstaImage from "@src/components/InstaImage";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuDeliveryHarajukuTakeoutImage } from "@src/constants/images";
import { meta as theGreatBurgerPageMeta } from "./the_great_burger.mdx";
import { meta as naprePageMeta } from "./napre.mdx";
import { meta as kevelosPageMeta } from "./kevelos.mdx";
import { meta as micasadecoPageMeta } from "./micasadeco.mdx";
export const meta = {
  path: "/media/harajuku/delivery",
  title: "【Uber Eatsあり】原宿の名店の味がデリバリーできるお店をジャンル別でご紹介",
  description: "原宿の百名店や食べログの高評価のお店で、デリバリーができるお店を厳選してご紹介します。原宿の行列店だからこそ、なるべく並ばずに自宅で食べたい方や、普段は家で食事がしたい方に必見のデリバリーになります！Uber Eatsが使えるお店もご紹介しますので、ぜひご覧ください。",
  topImg: harajukuDeliveryHarajukuTakeoutImage,
  author: murakamiMasanori,
  tags: ["原宿", "有名店", "人気店", "まとめ記事", "メニュー詳細", "デリバリー", "テイクアウト", "ハンバーガー", "イタリアン", "パンケーキ"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`原宿の百名店や食べログの高評価のお店で、デリバリーができるお店を厳選してご紹介します。`}</p>
    <p>{`選びやすいようにジャンル別に厳選し、Uber Eats ができるお店も合わせてご紹介させていただきます。原宿の行列店だからこそ、なるべく並ばずに自宅で食べたい方や、普段は家で食事がしたい方に必見のデリバリーになります！`}</p>
    <p>{`デリバリー限定のメニューを展開しているお店もあるので、ぜひご覧ください。`}</p>
    <h2>{`【バーガー】ザ グレートバーガー`}</h2>
    <InstaImage postId="B-GlOifHFbH" mdxType="InstaImage" />
    <p>{`原宿エリアで不動の人気を誇る原宿・表参道のハンバーガーの名店。3 年連続食べログ百名店に選出されるその人気は、天然酵母を使い、　オーナーが半年かけて制作した特製のバンズや、　ジューシーな憎々しいハンバーガーが食べられます。休日に長蛇の列を作り続けるグレイトバーガーのこデリバリーメニューについてお伝えします。`}</p>
    <h3>{`アボカドモッツアレラバーガー(1,800 円)`}</h3>
    <InstaImage postId="BbGD99MnyZT" mdxType="InstaImage" />
    <p>{`デリバリー問わず一番人気のメニューが、こちらのアボカドモッツアレラバーガーになります！`}</p>
    <h3>{`ベーコンチーズバーガー(1,863 円)`}</h3>
    <InstaImage postId="B-Ew-Mjl6rl" mdxType="InstaImage" />
    <p>{`香ばしいベーコンと肉肉しさがマッチするメニューで、デリバリーでも食べられる一品`}</p>
    <h3>{`ハラペーニョチーズバーガー(1,800 円)`}</h3>
    <InstaImage postId="B2_tYmiDrg0" mdxType="InstaImage" />
    <p>{`酸味の効いたハラペーニョはちょっと大人な味ですが、アクセントのついたメニューが食べたい方はこちらのメニューを！`}</p>
    <LinkWithThumbnail meta={theGreatBurgerPageMeta} mdxType="LinkWithThumbnail" />
    <hr></hr>
    <h2>{`【バーガー】The 3rd burger`}</h2>
    <InstaImage postId="B2f0D1vjtLb" mdxType="InstaImage" />
    <p>{`表参道と青山の中間地点に位置する人気のハンバーガショップ the 3rd Burger も、3 年連続百名店に選ばれている人気店。
他のお店と違うのは、美味しいのにお手頃な値段でハンバーガーを食べることができ、Uber Eats などデリバリーでも食べられるようになりました。`}</p>
    <h3>{`the オーセンティックバーガー(790 円)`}</h3>
    <InstaImage postId="B9uxFo4AbVO" mdxType="InstaImage" />
    <p>{`the 3rd Burger で一番人気のメニューがデリバリー でも堪能できます！`}</p>
    <h3>{`the 3rd Burger(550 円)`}</h3>
    <InstaImage postId="BqoWK0sgBeT" mdxType="InstaImage" />
    <p>{`the 3rd Burger のベーシックなメニューで、値段がお手頃何のしっかりとした食感とボリュームがあるメニュー。
新鮮な野菜も入っているので、健康に優しい点が女子の人気を得ている理由の一つなのだと思います。`}</p>
    <h4>{`モッツアレラバジルバーガー ¥590`}</h4>
    <InstaImage postId="BZf5Iu0FqCZ" mdxType="InstaImage" />
    <p>{`たっぷりモッツアレラのまろやかな風味とアクセントのあるバジルが、バーガーのパテの味を最大限に引き出してくれる一品になっています。
他のお店ではあまり食べられないバジルが効いたバーガー！`}</p>
    <hr></hr>
    <h2>{`【バーガー】ゴールデンブラウン`}</h2>
    <InstaImage postId="B9zHrwrgqKU" mdxType="InstaImage" />
    <p>{`表参道ヒルズの 3 階に位置するゴールデンブラウンも、食べログのハンバーガー部門で 3 年連続百名店に選出されています。
海外雑誌『monocle magazine』が選ぶ「世界の 100 アイテム」のベストバーガーに選出されたことがあるなど、ハンバーガー業界では知らない人はいない名店。
そんなゴールデンブラウンがデリバリーを始めたのでご紹介させていただきます。`}</p>
    <h3>{`エッグベーコンバーガー(1,470 円)`}</h3>
    <p>{`フレンンチフライ付`}</p>
    <InstaImage postId="Bxx_Zt2AQDU" mdxType="InstaImage" />
    <p>{`ボリュームのあるエッグに塩っけのある香ばしいベーコンが挟まれたボリューム感のあるバーガー！`}</p>
    <h3>{`クラシックハンバーガー(1,580 円)`}</h3>
    <p>{`フレンンチフライ付`}</p>
    <InstaImage postId="B0xljO2gu00" mdxType="InstaImage" />
    <h3>{`【UBER 限定】ダブルデッカーバーガー(1,980 円)`}</h3>
    <p>{`フレンンチフライ付`}</p>
    <InstaImage postId="B3qforAhrzl" mdxType="InstaImage" />
    <p>{`デリバリー限定のメニューになっているダブルデッカーバーガー！
ゴールデンブラウンを食べたことがある方は、新しいメニューに挑戦してみてください。`}</p>
    <hr></hr>
    <h2>{`【ピザ】ナプレ`}</h2>
    <InstaImage postId="CAwdI6NnR_D" mdxType="InstaImage" />
    <p>{`ナポリ・ピザ大会で入賞したピッツァイオーロ(ピザ職人のイタリアでの名称)が焼いてくれる本物のナポリピザ。2018 年は百名店にも選ばれており、特に一番ピザの味がわかると言われているマリナーラが一番の人気メニュー。本場イタリアのこだわりの食材を使った料理は本場のイタリア人も認める原宿の人気店。ナプレも 2020 年になってからデリバリーを始めました！`}</p>
    <h3>{`マリナーラ(1,800 円)`}</h3>
    <InstaImage postId="B1LjNrmgccK" mdxType="InstaImage" />
    <h3>{`マルゲリータ(2,000 円)`}</h3>
    <InstaImage postId="B-YUwP5gAp6" mdxType="InstaImage" />
    <h3>{`プロシュット　エ　ルーコラ(2,700 円)`}</h3>
    <InstaImage postId="B9GovU9BwWZ" mdxType="InstaImage" />
    <LinkWithThumbnail meta={naprePageMeta} mdxType="LinkWithThumbnail" />
    <hr></hr>
    <h2>{`【ピザ】ケベロス`}</h2>
    <InstaImage postId="B9BCBRqjP4M" mdxType="InstaImage" />
    <p><strong parentName="p">{`2,500 円以上`}</strong>{`の注文の場合のみ、デリバリーを実施しているのがピザの人気店ケベロス。こちらも食べログの評価が高いお店になっていて、インスタグラムを見るとたくさんのマリナーラの写真を見ることができます。`}</p>
    <h3>{`マリナーラ(1,300 円)`}</h3>
    <InstaImage postId="B-Zr1RslN5R" mdxType="InstaImage" />
    <p>{`「トマト、バジル、熟成ニンニク、オレガノ(ハーブのような葉っぱ)」の４種類しか使わないシンプルなピザ「マリナーラ」。
このピザがなんと`}<strong parentName="p">{`ケベロス(KEVELOS)の 1 番人気`}</strong>{`で、デリバリーでも一番人気になっています。`}</p>
    <h3>{`フィレマリナーラ(税込：1,500 円)`}</h3>
    <InstaImage postId="B0KdOrSBoHw" mdxType="InstaImage" />
    <InstaImage postId="BKajepyjZMu" mdxType="InstaImage" />
    <p>{`マリナーラをベースとして、チェリートマト加わったの甘みと酸味のあるピザ！
シンプル故にピッツァメニューの中で一番テクニックを要するピザで、ケベロス(KEVELOS)の常連さんに人気のピザになってます！`}</p>
    <h3>{`マルゲリータ(税込：1,500 円)`}</h3>
    <InstaImage postId="B2UA6RAlSg-" mdxType="InstaImage" />
    <InstaImage postId="B8JBTWMHpmt" mdxType="InstaImage" />
    <p>{`とろとろのモッツァレラチーズ、トマト、バジルで作る王道のピザになります！
いつも食べている基本のピザが食べたい方にはオススメのピザです！`}</p>
    <LinkWithThumbnail meta={kevelosPageMeta} mdxType="LinkWithThumbnail" />
    <hr></hr>
    <h2>{`【パンケーキ】ミカサデコカフェ`}</h2>
    <InstaImage postId="B9qDzXqguvS" mdxType="InstaImage" />
    <p>{`東京、大阪、京都に３店舗を構えるパンケーキの人気店で、原宿店が 2020 年 3 月に神宮前に場所を移転してリニューアルオープンしたばかり！
1 番人気のパンケーキだけでなく、月替りのランチメニューなど、素材にこだわった食事が食べられるお店として人気上昇中！`}</p>
    <h3>{`もちもちプレーンパンケーキ(900 円)`}</h3>
    <InstaImage postId="B-uAnlyBClT" mdxType="InstaImage" />
    <p>{`シンプルだけどしっかり味がついていて、何よりもふわふわなパンケーキ！
このパンケーキを求めて、原宿店舗では行列ができています。
これがテイクアウトで食べられるなんて…！`}</p>
    <h3>{`ココナッツカスタードパンケーキ(税込：1,200 円)`}</h3>
    <InstaImage postId="BPpg5PfBlsz" mdxType="InstaImage" />
    <p>{`濃厚なカスタードと甘いココナッツの風味が、ふわふわのパンケーキと合わさった人気メニュー！
こちらも通常メニューとして販売しているメニューがテイクアウトに！`}</p>
    <LinkWithThumbnail meta={micasadecoPageMeta} mdxType="LinkWithThumbnail" />
    <hr></hr>
    <h3>{`おわりに　`}</h3>
    <p>{`原宿エリアでデリバリーができる名店をピックアップしてご紹介させていただきましたが、いかがでしたでしょうか。普段行列ができる名店だからこそ、自宅でゆっくり並ばずに食べられる機会が増えてきたので、ぜひこの機会にデリバリーで素敵なお時間をお過ごしください！`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;